import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const MissionPage = lazy(() => import('../pages/mission/page'));
const TaxAccountantGuidePage = lazy(() => import('../pages/tax-accountant-guide/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const NakaiMiwaPage = lazy(() => import('../pages/testimonials/interview/nakai-miwa/page'));
const OkadaManabuPage = lazy(() => import('../pages/testimonials/interview/okada-manabu/page'));
const InouePage = lazy(() => import('../pages/testimonials/interview/inoue/page'));
const OnishiPage = lazy(() => import('../pages/testimonials/interview/onishi/page'));
const CompanyHistoryProfilePage = lazy(() => import('../pages/blog/company-history-profile/page'));
const BusinessPlanningPage = lazy(() => import('../pages/blog/business-planning/page'));
const MultipleIncomePage = lazy(() => import('../pages/blog/multiple-income/page'));
const CashRegisterManagementPage = lazy(() => import('../pages/blog/cash-register-management/page'));
const DepreciationPage = lazy(() => import('../pages/blog/depreciation/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/mission',
    element: <MissionPage />,
  },
  {
    path: '/tax-accountant-guide',
    element: <TaxAccountantGuidePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/testimonials/interview/nakai-miwa',
    element: <NakaiMiwaPage />,
  },
  {
    path: '/testimonials/interview/okada-manabu',
    element: <OkadaManabuPage />,
  },
  {
    path: '/testimonials/interview/inoue',
    element: <InouePage />,
  },
  {
    path: '/testimonials/interview/onishi',
    element: <OnishiPage />,
  },
  {
    path: '/blog/company-history-profile',
    element: <CompanyHistoryProfilePage />,
  },
  {
    path: '/blog/business-planning',
    element: <BusinessPlanningPage />,
  },
  {
    path: '/blog/multiple-income',
    element: <MultipleIncomePage />,
  },
  {
    path: '/blog/cash-register-management',
    element: <CashRegisterManagementPage />,
  },
  {
    path: '/blog/depreciation',
    element: <DepreciationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;